<!-- 联系我们 -->
<template>
  <div class="contact">
    <div class="banner"></div>
    <div class="content">
      <h1>{{ articleData.title }}</h1>
      <div v-html="articleData.content" class="fuwenben">
        <!-- <div class="map"><img src="../assets/map.png" alt="" /></div>
        <div class="message">
          <li>
            联系地址：
            <p>河北省邢台市信都区守敬北路锦鼎国际广场2号楼1205室</p>
          </li>
          <li>
            电 话：
            <p>0319-2600303</p>
          </li>
          <li>
            传 真：
            <p>400-666-0904</p>
          </li>
          <li>
            Q Q：
            <p>2582562234</p>
          </li>
          <li>
            邮 箱：
            <p>new737371@seasoft.com</p>
          </li>
          <li>
            邮政编码：
            <p>054000</p>
          </li>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { geContactUs } from "../api/userApi";
export default {
  data() {
    return {
      articleData: "",
    };
  },
  async created() {
    // 获取用户信息
    await this.geContactUs();
  },
  methods: {
    async geContactUs() {
      try {
        const response = await geContactUs();
        console.log(response.data);
        if (response.code === 1) {
          this.articleData = response.data;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.fuwenben {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  text-align: left;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  padding-bottom: 120px;
  padding-top: 45px;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #1c1d25;
    // margin: 45px 0;
  }
  .main_bottom {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
    .map {
      margin-right: 45px;
      width: 100%;
      max-width: 637px;
      max-height: 308px;
      img {
        width: 100%;
      }
    }
    .message {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      li {
        display: flex;
        margin-bottom: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      li:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
</style>
